import { ReactElement } from 'react';
import { Button } from 'antd';
import { FooterBlock, StatusText, ButtonGroup } from './ContentFooter.style';

interface Props {
  total: number;
  maxRows: number;
  onCancel: () => void;
}

const ContentFooter = ({ total, maxRows, onCancel }: Props): ReactElement => {
  const remainingCount = maxRows - total;
  return (
    <FooterBlock>
      <StatusText>
        <span>残り追加可能: {remainingCount}行</span>
      </StatusText>
      <ButtonGroup>
        <Button onClick={onCancel}>キャンセル</Button>
        <Button type='primary' htmlType='submit'>
          一括保存
        </Button>
      </ButtonGroup>
    </FooterBlock>
  );
};

export default ContentFooter;
